export default{
  data(){
    return{
      updateLanguage:0,
    }
  },
    methods: {
      onStep1Update:function() {
        return this.updateLanguage += 1;
       },
   }
}